module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.reducers = exports.default = undefined;

	var _component = __webpack_require__(1);

	var _component2 = _interopRequireDefault(_component);

	var _relay = __webpack_require__(44);

	var _relay2 = _interopRequireDefault(_relay);

	var _redux = __webpack_require__(46);

	var _redux2 = _interopRequireDefault(_redux);

	var _reducers = __webpack_require__(47);

	var _reducers2 = _interopRequireDefault(_reducers);

	var _recompose = __webpack_require__(35);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var wrappedComponent = (0, _recompose.hoistStatics)((0, _recompose.compose)(_relay2.default, _redux2.default))(_component2.default);

	exports.default = wrappedComponent;
	exports.reducers = _reducers2.default;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _dibsElements = __webpack_require__(4);

	var _copyText = __webpack_require__(5);

	var _copyText2 = _interopRequireDefault(_copyText);

	var _tracking = __webpack_require__(6);

	var _tracking2 = _interopRequireDefault(_tracking);

	var _Shipping = __webpack_require__(8);

	var _Shipping2 = _interopRequireDefault(_Shipping);

	var _SuccessContent = __webpack_require__(28);

	var _SuccessContent2 = _interopRequireDefault(_SuccessContent);

	var _copy = __webpack_require__(19);

	var _copy2 = _interopRequireDefault(_copy);

	var _styles = __webpack_require__(33);

	var _styles2 = _interopRequireDefault(_styles);

	__webpack_require__(14);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var RequestShippingQuoteModal = function (_Component) {
	    _inherits(RequestShippingQuoteModal, _Component);

	    function RequestShippingQuoteModal(props) {
	        _classCallCheck(this, RequestShippingQuoteModal);

	        var _this = _possibleConstructorReturn(this, (RequestShippingQuoteModal.__proto__ || Object.getPrototypeOf(RequestShippingQuoteModal)).call(this, props));

	        _this.copy = (0, _copyText2.default)().extend(_copy2.default);

	        _this.hasInitialStepOverride = _react2.default.Children.count(_this.props.children) === 1;

	        _this.onSuccess = _this.onSuccess.bind(_this);
	        _this.onFailure = _this.onFailure.bind(_this);
	        return _this;
	    }

	    _createClass(RequestShippingQuoteModal, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _props = this.props,
	                isOpened = _props.isOpened,
	                modalKey = _props.modalKey,
	                userId = _props.userId,
	                relay = _props.relay,
	                setOpenModalKey = _props.setOpenModalKey,
	                setCurrentStep = _props.setCurrentStep,
	                clearState = _props.clearState;


	            if (!isOpened && nextProps.isOpened) {
	                setOpenModalKey(modalKey);

	                if (this.hasInitialStepOverride) {
	                    setCurrentStep('initialStepOverride');
	                }
	            }

	            if (isOpened && !nextProps.isOpened) {
	                clearState();
	            }

	            if (!userId && nextProps.userId) {
	                relay.setVariables({ currentUserId: userId });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.clearState();
	        }
	    }, {
	        key: 'onSuccess',
	        value: function onSuccess() {
	            var _props2 = this.props,
	                trackingLocation = _props2.trackingLocation,
	                setCurrentStep = _props2.setCurrentStep;

	            _tracking2.default.trackSubmitted({ label: trackingLocation });
	            setCurrentStep('requestSuccess');
	        }
	    }, {
	        key: 'onFailure',
	        value: function onFailure() {
	            this.props.setErrorMessage({ errorMessage: this.copy.get('sqrMutationError') });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                relay = _props3.relay,
	                user = _props3.user,
	                environment = _props3.environment,
	                isOpened = _props3.isOpened,
	                requestedShipmentQuote = _props3.requestedShipmentQuote,
	                conversationId = _props3.conversationId,
	                currentStep = _props3.currentStep,
	                buyerDisplayName = _props3.buyerDisplayName,
	                onOpen = _props3.onOpen,
	                children = _props3.children,
	                onShowQuoteRequest = _props3.onShowQuoteRequest,
	                setCurrentStep = _props3.setCurrentStep,
	                closeShippingModal = _props3.closeShippingModal,
	                clearState = _props3.clearState,
	                transactionIsCanceled = _props3.transactionIsCanceled,
	                transactionId = _props3.transactionId,
	                transactionHasCompletedCheckout = _props3.transactionHasCompletedCheckout,
	                userId = _props3.userId,
	                userRelayId = _props3.userRelayId,
	                itemId = _props3.itemId,
	                itemTitle = _props3.itemTitle,
	                seller = _props3.seller,
	                dealerPk = _props3.dealerPk,
	                isMC = _props3.isMC,
	                trackingLocation = _props3.trackingLocation,
	                conversationRelayId = _props3.conversationRelayId,
	                transactionRelayId = _props3.transactionRelayId,
	                pageContext = _props3.pageContext,
	                errorMessage = _props3.errorMessage;

	            var shouldShowSuccess = currentStep === 'requestSuccess';
	            var hasOverrideInitialStep = currentStep === 'initialStepOverride';
	            var shouldShowSQR = !hasOverrideInitialStep && !shouldShowSuccess;

	            // user may submit another request if transaction was canceled
	            if (isOpened && currentStep === 'quoteRequest' && !transactionIsCanceled) {
	                if (transactionHasCompletedCheckout) {
	                    window.location.href = '/my/orders/order/' + transactionId + '/';
	                } else if (requestedShipmentQuote) {
	                    window.location.href = '/my/conversations/' + conversationId + '/';
	                }
	            }

	            var handleBackClick = function handleBackClick() {
	                clearState();
	                setCurrentStep('initialStepOverride');
	            };

	            var barHeaderTitle = shouldShowSuccess ? this.copy.get('sqrSuccessHeader') : this.copy.get('sqrHeader');

	            return _react2.default.createElement(
	                _dibsElements.ModalContainer,
	                {
	                    modalClass: _styles2.default.sqrModalWrapper,
	                    isOpen: isOpened,
	                    onOpen: onOpen,
	                    onClose: closeShippingModal,
	                    modalSize: 'medium'
	                },
	                _react2.default.createElement(_dibsElements.ModalCloseButton, { onClick: closeShippingModal }),
	                hasOverrideInitialStep && !shouldShowSuccess && _react2.default.cloneElement(_react2.default.Children.only(children), {
	                    openQuoteRequestModal: function openQuoteRequestModal() {
	                        setCurrentStep('quoteRequest');
	                        _tracking2.default.trackClicked({ label: trackingLocation });
	                        if (onShowQuoteRequest) {
	                            onShowQuoteRequest();
	                        }
	                    },
	                    closeModal: closeShippingModal
	                }),
	                shouldShowSQR && _react2.default.createElement(_dibsElements.BarHeader, { title: barHeaderTitle }),
	                shouldShowSQR && _react2.default.createElement(
	                    _dibsElements.ModalBody,
	                    null,
	                    _react2.default.createElement(_Shipping2.default, {
	                        relay: relay,
	                        user: user,
	                        buyerDisplayName: buyerDisplayName,
	                        environment: environment,
	                        userId: userId,
	                        itemId: itemId,
	                        itemTitle: itemTitle,
	                        conversationId: conversationId,
	                        dealerPk: dealerPk,
	                        transactionId: transactionId,
	                        conversationRelayId: conversationRelayId,
	                        transactionRelayId: transactionRelayId,
	                        userRelayId: userRelayId,
	                        pageContext: pageContext,
	                        copy: this.copy,
	                        onSuccess: this.onSuccess,
	                        onFailure: this.onFailure
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.sqrError },
	                        errorMessage
	                    ),
	                    children ? _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.sqrFooterBackLink, onClick: handleBackClick },
	                        this.copy.get('sqrBack')
	                    ) : null
	                ),
	                shouldShowSuccess && _react2.default.createElement(_SuccessContent2.default, {
	                    isMC: isMC,
	                    userId: userId,
	                    seller: seller,
	                    copy: this.copy
	                })
	            );
	        }
	    }]);

	    return RequestShippingQuoteModal;
	}(_react.Component);

	RequestShippingQuoteModal.propTypes = {
	    environment: _propTypes2.default.object.isRequired,
	    isOpened: _propTypes2.default.bool,
	    viewer: _propTypes2.default.object,
	    relay: _propTypes2.default.object,
	    userId: _propTypes2.default.string,
	    conversationId: _propTypes2.default.string,
	    transactionId: _propTypes2.default.string,
	    itemId: _propTypes2.default.string.isRequired,
	    dealerPk: _propTypes2.default.string.isRequired,
	    setCurrentStep: _propTypes2.default.func,
	    setErrorMessage: _propTypes2.default.func,
	    requestedShipmentQuote: _propTypes2.default.object,
	    buyerDisplayName: _propTypes2.default.string,
	    onOpen: _propTypes2.default.func,
	    children: _propTypes2.default.object,
	    openQuoteRequestModal: _propTypes2.default.func,
	    itemTitle: _propTypes2.default.string,
	    userRelayId: _propTypes2.default.string,
	    conversationRelayId: _propTypes2.default.string,
	    transactionRelayId: _propTypes2.default.string,
	    clearState: _propTypes2.default.func,
	    pageContext: _propTypes2.default.string,
	    trackingLocation: _propTypes2.default.string,
	    currentStep: _propTypes2.default.string,
	    onShowQuoteRequest: _propTypes2.default.func,
	    transactionIsCanceled: _propTypes2.default.bool,
	    transactionHasCompletedCheckout: _propTypes2.default.bool,
	    closeShippingModal: _propTypes2.default.func,
	    modalKey: _propTypes2.default.string,
	    setOpenModalKey: _propTypes2.default.func,
	    user: _propTypes2.default.object,
	    seller: _propTypes2.default.object,
	    isMC: _propTypes2.default.bool,
	    errorMessage: _propTypes2.default.string
	};

	RequestShippingQuoteModal.defaultProps = {
	    pageContext: 'DEALER_SHIPPING_REQUEST'
	};

	exports.default = RequestShippingQuoteModal;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = require("react");

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = require("prop-types");

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = require("dibs-elements");

/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = require("copy-text");

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _dibsTracking = __webpack_require__(7);

	var _dibsTracking2 = _interopRequireDefault(_dibsTracking);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var trackFollowDealer = function trackFollowDealer(_ref) {
	    var isMC = _ref.isMC,
	        action = _ref.action;
	    return _dibsTracking2.default.trackEvent({
	        category: 'dealer favoriting',
	        label: isMC ? 'message center' : 'pdp',
	        action: action
	    });
	};

	var sqrTracking = {
	    trackClicked: function trackClicked(_ref2) {
	        var label = _ref2.label;
	        return _dibsTracking2.default.trackEvent({
	            action: 'request shipping quote clicked',
	            category: 'product',
	            label: label
	        });
	    },
	    trackSubmitted: function trackSubmitted(_ref3) {
	        var label = _ref3.label;
	        return _dibsTracking2.default.trackEvent({
	            action: 'request shipping quote submitted',
	            category: 'product',
	            label: label
	        });
	    },
	    trackDealerFollowed: function trackDealerFollowed(_ref4) {
	        var isMC = _ref4.isMC;
	        return trackFollowDealer({ isMC: isMC, action: 'dealer added' });
	    },
	    trackDealerUnFollowed: function trackDealerUnFollowed(_ref5) {
	        var isMC = _ref5.isMC;
	        return trackFollowDealer({ isMC: isMC, action: 'dealer removed' });
	    }
	};

	exports.default = sqrTracking;

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = require("dibs-tracking");

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(9);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _shipping = __webpack_require__(10);

	var _shipping2 = _interopRequireDefault(_shipping);

	__webpack_require__(14);

	var _updateBuyerProfileMutation = __webpack_require__(15);

	var _updateBuyerProfileMutation2 = _interopRequireDefault(_updateBuyerProfileMutation);

	var _UserAddAddressMutation = __webpack_require__(17);

	var _UserAddAddressMutation2 = _interopRequireDefault(_UserAddAddressMutation);

	var _requestShipmentQuoteMutation = __webpack_require__(18);

	var _requestShipmentQuoteMutation2 = _interopRequireDefault(_requestShipmentQuoteMutation);

	var _dibsAddressForm = __webpack_require__(20);

	var _dibsAddressForm2 = _interopRequireDefault(_dibsAddressForm);

	var _Select = __webpack_require__(21);

	var _Select2 = _interopRequireDefault(_Select);

	var _Option = __webpack_require__(24);

	var _Option2 = _interopRequireDefault(_Option);

	var _Submit = __webpack_require__(25);

	var _Submit2 = _interopRequireDefault(_Submit);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var OPTIONS = {
	    OPTION_NEW: 'NEW',
	    OPTION_ADD: 'ADD',
	    OPTION_EXIST: 'EXIST',
	    OPTION_REQUEST: 'REQUEST'
	};

	// mutations


	// components

	var Shipping = function (_Component) {
	    _inherits(Shipping, _Component);

	    function Shipping(props) {
	        _classCallCheck(this, Shipping);

	        var _this = _possibleConstructorReturn(this, (Shipping.__proto__ || Object.getPrototypeOf(Shipping)).call(this, props));

	        var firstValidShippingAddressId = (0, _lodash2.default)(props, 'user.firstValidShippingAddress.serviceId');
	        var shippingAddress = (0, _lodash2.default)(props, 'transaction.shipment.shippingAddress') || {};
	        var shippingAddressId = shippingAddress.sourceId || shippingAddress.serviceId;
	        var addressList = (0, _lodash2.default)(props, 'user.addressBook.addressList') || [];
	        var addressExist = addressList.find(function (a) {
	            return a.serviceId === shippingAddressId;
	        });
	        var isExist = !!(shippingAddressId && addressExist);
	        var selectedAddressId = isExist && shippingAddressId || firstValidShippingAddressId || null;

	        _this.onChange = _this.onChange.bind(_this);
	        _this.failureHandler = _this.failureHandler.bind(_this);
	        _this.onSubmit = _this.onSubmit.bind(_this);

	        _this.state = {
	            selected: selectedAddressId || OPTIONS.OPTION_ADD,
	            selectedAddress: selectedAddressId,
	            isSaving: false
	        };
	        return _this;
	    }

	    _createClass(Shipping, [{
	        key: 'onChange',
	        value: function onChange(event) {
	            var selected = event.target.value;

	            var selectedAddress = selected === OPTIONS.OPTION_ADD ? this.state.selectedAddress : selected;
	            this.setState({ selected: selected, selectedAddress: selectedAddress });
	        }
	    }, {
	        key: 'failureHandler',
	        value: function failureHandler() {
	            this.setState({ isSaving: false });
	            this.props.onFailure();
	        }
	    }, {
	        key: 'requestShipmentQuote',
	        value: function requestShipmentQuote(address) {
	            var _props = this.props,
	                relay = _props.relay,
	                userId = _props.userId,
	                user = _props.user,
	                itemId = _props.itemId,
	                itemTitle = _props.itemTitle,
	                conversationId = _props.conversationId,
	                dealerPk = _props.dealerPk,
	                transactionId = _props.transactionId,
	                conversationRelayId = _props.conversationRelayId,
	                transactionRelayId = _props.transactionRelayId,
	                userRelayId = _props.userRelayId,
	                pageContext = _props.pageContext,
	                onSuccess = _props.onSuccess;


	            var requestQuote = new _requestShipmentQuoteMutation2.default({
	                userId: userId,
	                itemId: itemId,
	                dealerPk: dealerPk,
	                conversationId: conversationId,
	                transactionId: transactionId,
	                conversationRelayId: conversationRelayId,
	                transactionRelayId: transactionRelayId,
	                userRelayId: userRelayId,
	                itemTitle: itemTitle,
	                pageContext: pageContext,
	                shippingAddressId: address.serviceId
	            });

	            var _ref = (0, _lodash2.default)(user, 'profile') || {},
	                firstName = _ref.firstName,
	                lastName = _ref.lastName;

	            /**
	             * If firstName and lastName are undefined update user profile with display name,
	             * then request a shipping quote
	             */


	            if (!firstName && !lastName) {
	                return relay.commitUpdate(new _updateBuyerProfileMutation2.default({
	                    displayName: address.firstName + ' ' + address.lastName,
	                    userId: userId,
	                    userRelayId: userRelayId
	                }), {
	                    onSuccess: relay.commitUpdate(requestQuote, {
	                        onSuccess: onSuccess,
	                        onFailure: this.failureHandler
	                    }),
	                    onFailure: this.failureHandler
	                });
	            }

	            return relay.commitUpdate(requestQuote, {
	                onSuccess: onSuccess,
	                onFailure: this.failureHandler
	            });
	        }
	    }, {
	        key: 'onSubmit',
	        value: function onSubmit(_ref2) {
	            var _this2 = this;

	            var address = _ref2.address,
	                isValid = _ref2.isValid;
	            var selected = this.state.selected;
	            var _props2 = this.props,
	                relay = _props2.relay,
	                user = _props2.user,
	                userId = _props2.userId;


	            var isAdding = selected === OPTIONS.OPTION_ADD;
	            var existingAddress = ((0, _lodash2.default)(user, 'addressBook.addressList') || []).find(function (a) {
	                return a.serviceId === selected;
	            });
	            isValid = isValid || !isAdding && !!existingAddress;

	            if (isValid) {
	                this.setState({ isSaving: true });

	                if (isAdding) {
	                    relay.commitUpdate(new _UserAddAddressMutation2.default({
	                        userId: userId,
	                        address: address
	                    }), {
	                        onSuccess: function onSuccess(payload) {
	                            _this2.requestShipmentQuote((0, _lodash2.default)(payload, 'userAddAddress.address'));
	                        },
	                        onFailure: this.failureHandler
	                    });
	                } else {
	                    this.requestShipmentQuote(existingAddress);
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                selected = _state.selected,
	                selectedAddress = _state.selectedAddress,
	                isSaving = _state.isSaving;
	            var _props3 = this.props,
	                environment = _props3.environment,
	                user = _props3.user,
	                copy = _props3.copy;

	            var isAdding = selected === OPTIONS.OPTION_ADD;
	            var addresses = ((0, _lodash2.default)(user, 'addressBook.addressList') || []).filter(function (a) {
	                return (0, _lodash2.default)(a, 'validation.buyerShipping.valid');
	            });
	            var addressOptions = addresses.map(function (address) {
	                return {
	                    value: address.serviceId,
	                    label: [address.displayName].concat(address.formattedAddress, [address.displayCountry]).join(', ')
	                };
	            });
	            var showAddresses = !!addressOptions.length;
	            var showAddressForm = isAdding || !addresses.length;

	            return _react2.default.createElement(
	                'div',
	                null,
	                showAddresses && _react2.default.createElement(
	                    'div',
	                    { className: _shipping2.default.subContentWrapper },
	                    _react2.default.createElement(_Option2.default, {
	                        label: copy.get('sqrAddFromSavedAddresses'),
	                        value: selectedAddress,
	                        checked: selected !== OPTIONS.OPTION_ADD,
	                        isDisabled: isSaving,
	                        onChange: this.onChange
	                    }),
	                    !showAddressForm && _react2.default.createElement(_Select2.default, {
	                        wrapperClasses: _shipping2.default.subContent,
	                        name: 'address',
	                        value: selectedAddress,
	                        options: addressOptions,
	                        isDisabled: isSaving,
	                        onChange: this.onChange
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _shipping2.default.subContentWrapper },
	                    showAddresses && _react2.default.createElement(_Option2.default, {
	                        label: copy.get('sqrAddNewAddress'),
	                        value: OPTIONS.OPTION_ADD,
	                        checked: isAdding,
	                        isDisabled: isSaving,
	                        onChange: this.onChange
	                    }),
	                    showAddressForm && _react2.default.createElement(_dibsAddressForm2.default, {
	                        environment: environment,
	                        formClass: showAddresses ? _shipping2.default.subContent : _shipping2.default.singleFormWrapper,
	                        submitLabel: copy.get('sqrSend'),
	                        onSubmit: this.onSubmit
	                    })
	                ),
	                !showAddressForm && _react2.default.createElement(_Submit2.default, {
	                    label: copy.get('sqrSend'),
	                    isSaving: isSaving,
	                    onClick: this.onSubmit
	                })
	            );
	        }
	    }]);

	    return Shipping;
	}(_react.Component);

	Shipping.propTypes = {
	    relay: _propTypes2.default.object.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    environment: _propTypes2.default.object.isRequired,
	    userId: _propTypes2.default.string,
	    itemId: _propTypes2.default.string.isRequired,
	    itemTitle: _propTypes2.default.string,
	    conversationId: _propTypes2.default.string,
	    dealerPk: _propTypes2.default.string.isRequired,
	    transactionId: _propTypes2.default.string,
	    conversationRelayId: _propTypes2.default.string,
	    transactionRelayId: _propTypes2.default.string,
	    userRelayId: _propTypes2.default.string,
	    pageContext: _propTypes2.default.string,
	    copy: _propTypes2.default.object.isRequired,
	    onSuccess: _propTypes2.default.func.isRequired,
	    onFailure: _propTypes2.default.func.isRequired
	};

	exports.default = Shipping;

/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports = require("lodash.get");

/***/ },
/* 10 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"subContentWrapper":"src-ShippingRequestModal-shipping---subContentWrapper---10PIZ","subContent":"src-ShippingRequestModal-shipping---subContent---2c6Hb","fieldsWrapper":"src-ShippingRequestModal-shipping---fieldsWrapper---x7u6r","halfFieldLeft":"src-ShippingRequestModal-shipping---halfFieldLeft---fKnvJ","halfFieldRight":"src-ShippingRequestModal-shipping---halfFieldRight---3P0VW","halfFieldWrapper":"src-ShippingRequestModal-shipping---halfFieldWrapper---2oaIe src-ShippingRequestModal-shipping---fieldsWrapper---x7u6r src-ShippingRequestModal-shipping---halfFieldLeft---fKnvJ","halfFieldRightLabel":"src-ShippingRequestModal-shipping---halfFieldRightLabel---1ukCC src-ShippingRequestModal-shipping---halfFieldRight---3P0VW","singleFormWrapper":"src-ShippingRequestModal-shipping---singleFormWrapper---7z2X1","formContainer":"src-ShippingRequestModal-shipping---formContainer---2j_kE","label":"src-ShippingRequestModal-shipping---label---NMqM4","subLabel":"src-ShippingRequestModal-shipping---subLabel---fSn9Q","radioInput":"src-ShippingRequestModal-shipping---radioInput---uqeIT","addressInfoWrapper":"src-ShippingRequestModal-shipping---addressInfoWrapper---1Bq24","select":"src-ShippingRequestModal-shipping---select---2sR88","selectWrapper":"src-ShippingRequestModal-shipping---selectWrapper---1C-BK","selectTriangle":"src-ShippingRequestModal-shipping---selectTriangle---3yxc4","textareaWrapper":"src-ShippingRequestModal-shipping---textareaWrapper---3nN-y","textareaLabel":"src-ShippingRequestModal-shipping---textareaLabel---R_v2W","textarea":"src-ShippingRequestModal-shipping---textarea---1FPOS","quoteWrapper":"src-ShippingRequestModal-shipping---quoteWrapper---2nC56","quoteLabel":"src-ShippingRequestModal-shipping---quoteLabel---20H7Y","quote":"src-ShippingRequestModal-shipping---quote---3yxb5","quoteMethod":"src-ShippingRequestModal-shipping---quoteMethod---2kzFD src-ShippingRequestModal-shipping---quote---3yxb5","quoteDestination":"src-ShippingRequestModal-shipping---quoteDestination---3qAEM src-ShippingRequestModal-shipping---quote---3yxb5","quoteHandlingTime":"src-ShippingRequestModal-shipping---quoteHandlingTime---20_lA src-ShippingRequestModal-shipping---quote---3yxb5","quoteAmount":"src-ShippingRequestModal-shipping---quoteAmount---Tpxw0 src-ShippingRequestModal-shipping---quote---3yxb5","valid":"src-ShippingRequestModal-shipping---valid---32uDx","submit":"src-ShippingRequestModal-shipping---submit---2Azt6","disable":"src-ShippingRequestModal-shipping---disable---2V0Y7","error":"src-ShippingRequestModal-shipping---error---1Tnje","errorMessage":"src-ShippingRequestModal-shipping---errorMessage---3fVZH","inlineSpinner":"src-ShippingRequestModal-shipping---inlineSpinner---3OVZV"};

/***/ },
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports) {

	module.exports = require("dibs-address-form/dist/main.css");

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Relay = __webpack_require__(16);

	var BuyerProfileMutation = function (_Relay$Mutation) {
	    _inherits(BuyerProfileMutation, _Relay$Mutation);

	    function BuyerProfileMutation() {
	        _classCallCheck(this, BuyerProfileMutation);

	        return _possibleConstructorReturn(this, (BuyerProfileMutation.__proto__ || Object.getPrototypeOf(BuyerProfileMutation)).apply(this, arguments));
	    }

	    _createClass(BuyerProfileMutation, [{
	        key: 'getMutation',
	        value: function getMutation() {
	            return function () {
	                return {
	                    calls: [{
	                        kind: 'Call',
	                        metadata: {},
	                        name: 'updateBuyerProfileName',
	                        value: {
	                            kind: 'CallVariable',
	                            callVariableName: 'input'
	                        }
	                    }],
	                    children: [{
	                        fieldName: 'clientMutationId',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'String'
	                    }],
	                    kind: 'Mutation',
	                    metadata: {
	                        inputType: 'UpdateBuyerProfileNameInput!'
	                    },
	                    name: 'UpdateBuyerProfileMutation',
	                    responseType: 'UpdateBuyerProfileNamePayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getVariables',
	        value: function getVariables() {
	            var _props = this.props,
	                userId = _props.userId,
	                displayName = _props.displayName;


	            return {
	                userServiceId: userId,
	                displayName: displayName
	            };
	        }
	    }, {
	        key: 'getFatQuery',
	        value: function getFatQuery() {
	            return function () {
	                return {
	                    children: [{
	                        children: [{
	                            children: [{
	                                fieldName: 'displayName',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'firstName',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'lastName',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }],
	                            fieldName: 'profile',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true
	                            },
	                            type: 'Profile'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'user',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'User'
	                    }],
	                    id: Relay.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'UpdateBuyerProfileMutationRelayQL',
	                    type: 'UpdateBuyerProfileNamePayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getConfigs',
	        value: function getConfigs() {
	            return [{
	                type: 'FIELDS_CHANGE',
	                fieldIDs: { user: this.props.userRelayId }
	            }];
	        }
	    }]);

	    return BuyerProfileMutation;
	}(Relay.Mutation);

	BuyerProfileMutation.fragments = {
	    user: function user() {
	        return function () {
	            return {
	                children: [{
	                    fieldName: 'id',
	                    kind: 'Field',
	                    metadata: {
	                        isRequisite: true
	                    },
	                    type: 'ID'
	                }, {
	                    children: [{
	                        fieldName: 'displayName',
	                        kind: 'Field',
	                        metadata: {},
	                        type: 'String'
	                    }],
	                    fieldName: 'profile',
	                    kind: 'Field',
	                    metadata: {
	                        canHaveSubselections: true
	                    },
	                    type: 'Profile'
	                }],
	                id: Relay.QL.__id(),
	                kind: 'Fragment',
	                metadata: {},
	                name: 'UpdateBuyerProfileMutation_UserRelayQL',
	                type: 'User'
	            };
	        }();
	    }
	};

	module.exports = BuyerProfileMutation;

/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = require("react-relay");

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Relay = __webpack_require__(16);
	var React = __webpack_require__(2);
	var PropTypes = React.PropTypes;

	var UserAddAddressMutation = function (_Relay$Mutation) {
	    _inherits(UserAddAddressMutation, _Relay$Mutation);

	    function UserAddAddressMutation() {
	        _classCallCheck(this, UserAddAddressMutation);

	        return _possibleConstructorReturn(this, (UserAddAddressMutation.__proto__ || Object.getPrototypeOf(UserAddAddressMutation)).apply(this, arguments));
	    }

	    _createClass(UserAddAddressMutation, [{
	        key: 'getMutation',
	        value: function getMutation() {
	            return function () {
	                return {
	                    calls: [{
	                        kind: 'Call',
	                        metadata: {},
	                        name: 'userAddAddress',
	                        value: {
	                            kind: 'CallVariable',
	                            callVariableName: 'input'
	                        }
	                    }],
	                    children: [{
	                        fieldName: 'clientMutationId',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'String'
	                    }],
	                    kind: 'Mutation',
	                    metadata: {
	                        inputType: 'UserAddAddressInput!'
	                    },
	                    name: 'UserAddAddressMutation',
	                    responseType: 'UserAddAddressPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getVariables',
	        value: function getVariables() {
	            var _props = this.props,
	                userId = _props.userId,
	                address = _props.address;

	            return { userId: userId, address: address };
	        }
	    }, {
	        key: 'getFatQuery',
	        value: function getFatQuery() {
	            return function () {
	                return {
	                    children: [{
	                        children: [{
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'address',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Address'
	                    }],
	                    id: Relay.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'UserAddAddressMutationRelayQL',
	                    type: 'UserAddAddressPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getConfigs',
	        value: function getConfigs() {
	            return [{
	                type: 'REQUIRED_CHILDREN',
	                children: [function () {
	                    return {
	                        children: [{
	                            children: [{
	                                fieldName: 'serviceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'ID'
	                            }, {
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isGenerated: true,
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }],
	                            fieldName: 'address',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id'
	                            },
	                            type: 'Address'
	                        }],
	                        id: Relay.QL.__id(),
	                        kind: 'Fragment',
	                        metadata: {},
	                        name: 'UserAddAddressMutation_ChildrenRelayQL',
	                        type: 'UserAddAddressPayload'
	                    };
	                }()]
	            }];
	        }
	    }]);

	    return UserAddAddressMutation;
	}(Relay.Mutation);

	UserAddAddressMutation.propTypes = {
	    userId: PropTypes.string.isRequired,
	    address: PropTypes.shape({
	        firstName: PropTypes.string.isRequired,
	        lastName: PropTypes.string.isRequired,
	        company: PropTypes.string,
	        country: PropTypes.string.isRequired,
	        line1: PropTypes.string.isRequired,
	        line2: PropTypes.string,
	        zipCode: PropTypes.string.isRequired,
	        city: PropTypes.string.isRequired,
	        state: PropTypes.string.isRequired,
	        phoneNumber: PropTypes.string.isRequired
	    }).isRequired
	};

	module.exports = UserAddAddressMutation;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _copyText = __webpack_require__(5);

	var _copyText2 = _interopRequireDefault(_copyText);

	var _copy = __webpack_require__(19);

	var _copy2 = _interopRequireDefault(_copy);

	var _reactRelay = __webpack_require__(16);

	var _reactRelay2 = _interopRequireDefault(_reactRelay);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var copyObj = (0, _copyText2.default)().extend(_copy2.default);

	var RequestShipmentQuoteMutation = function (_Relay$Mutation) {
	    _inherits(RequestShipmentQuoteMutation, _Relay$Mutation);

	    function RequestShipmentQuoteMutation() {
	        _classCallCheck(this, RequestShipmentQuoteMutation);

	        return _possibleConstructorReturn(this, (RequestShipmentQuoteMutation.__proto__ || Object.getPrototypeOf(RequestShipmentQuoteMutation)).apply(this, arguments));
	    }

	    _createClass(RequestShipmentQuoteMutation, [{
	        key: 'getMutation',
	        value: function getMutation() {
	            return function () {
	                return {
	                    calls: [{
	                        kind: 'Call',
	                        metadata: {},
	                        name: 'shipmentQuoteRequest',
	                        value: {
	                            kind: 'CallVariable',
	                            callVariableName: 'input'
	                        }
	                    }],
	                    children: [{
	                        fieldName: 'clientMutationId',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'String'
	                    }],
	                    kind: 'Mutation',
	                    metadata: {
	                        inputType: 'ShipmentQuoteRequestInput!'
	                    },
	                    name: 'RequestShipmentQuoteMutation',
	                    responseType: 'ShipmentQuoteRequestPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getVariables',
	        value: function getVariables() {
	            var subject = copyObj.get('sqrSubjectLine') + ' ' + this.props.itemTitle;
	            var action = 'SHIPPING_REQUEST';
	            return {
	                // required fields:
	                buyerId: this.props.userId,
	                itemPk: this.props.itemId,
	                dealerPk: this.props.dealerPk,
	                subject: subject,
	                // optional fields:
	                shippingAddressId: this.props.shippingAddressId,
	                conversationId: this.props.conversationId,
	                country: this.props.country,
	                city: this.props.city,
	                message: this.props.message || '',
	                state: this.props.state,
	                transactionId: this.props.transactionId,
	                zipCode: this.props.zipCode,
	                pageContext: this.props.pageContext,
	                action: action
	            };
	        }
	    }, {
	        key: 'getFatQuery',
	        value: function getFatQuery() {
	            return function () {
	                return {
	                    children: [{
	                        children: [{
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }, {
	                            fieldName: 'serviceId',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'ID'
	                        }, {
	                            children: [{
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }, {
	                                fieldName: 'serviceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'ID'
	                            }],
	                            fieldName: 'transaction',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id'
	                            },
	                            type: 'Transaction'
	                        }],
	                        fieldName: 'conversation',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Conversation'
	                    }],
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'RequestShipmentQuoteMutationRelayQL',
	                    type: 'ShipmentQuoteRequestPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getConfigs',
	        value: function getConfigs() {
	            return [{
	                type: 'FIELDS_CHANGE',
	                fieldIDs: {
	                    conversation: this.props.conversationRelayId
	                }
	            }];
	        }
	    }]);

	    return RequestShipmentQuoteMutation;
	}(_reactRelay2.default.Mutation);

	module.exports = RequestShipmentQuoteMutation;

/***/ },
/* 19 */
/***/ function(module, exports) {

	module.exports = {
		"sqrHeader": "Add Shipping Address & Shipping Quote",
		"sqrSend": "Save & Continue",
		"sqrSuccessMessage": "Your request has been sent. You will be notified by email when a custom shipping quote is available for your review.",
		"sqrViewRequest": "You can view your request at any time in",
		"sqrMyConversations": "My Conversations",
		"sqrSuccessHeader": "Request Sent",
		"sqrAddFromSavedAddresses": "Add from saved addresses",
		"sqrAddNewAddress": "Add new address",
		"sqrSuccessFooterTitle": "stay up to date",
		"sqrSuccessFooterText": "Follow this dealer to get weekly updates on new arrivals.",
		"sqrBack": "back",
		"sqrSubjectLine": "1stdibs Shipping Quote Request for",
		"sqrMutationError": "There was an error submitting your request. Please refresh the page and try again."
	};

/***/ },
/* 20 */
/***/ function(module, exports) {

	module.exports = require("dibs-address-form");

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _lodash = __webpack_require__(9);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _classnames = __webpack_require__(22);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _shipping = __webpack_require__(10);

	var _shipping2 = _interopRequireDefault(_shipping);

	var _Select = __webpack_require__(23);

	var _Select2 = _interopRequireDefault(_Select);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var InvoiceSelect = function InvoiceSelect(_ref) {
	    var wrapperClasses = _ref.wrapperClasses,
	        name = _ref.name,
	        value = _ref.value,
	        options = _ref.options,
	        isDisabled = _ref.isDisabled,
	        _onChange = _ref.onChange;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(wrapperClasses, [_shipping2.default.selectWrapper]), 'data-field': 'addresses' },
	        _react2.default.createElement(_Select2.default, {
	            theme: _shipping2.default,
	            name: name,
	            value: value,
	            options: options,
	            searchable: false,
	            disabled: isDisabled,
	            onChange: function onChange(payload) {
	                return _onChange({ target: { name: name, value: (0, _lodash2.default)(payload, 'value') || '' } });
	            }
	        })
	    );
	};

	// components


	InvoiceSelect.propTypes = {
	    wrapperClasses: _propTypes2.default.string,
	    name: _propTypes2.default.any.isRequired,
	    value: _propTypes2.default.any.isRequired,
	    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        value: _propTypes2.default.any.isRequired,
	        label: _propTypes2.default.any.isRequired
	    })).isRequired,
	    isDisabled: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func.isRequired
	};

	InvoiceSelect.defaultProps = {
	    wrapperClasses: '',
	    isDisabled: false
	};

	exports.default = InvoiceSelect;

/***/ },
/* 22 */
/***/ function(module, exports) {

	module.exports = require("classnames");

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = require("dibs-elements/dist/Select");

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _shipping = __webpack_require__(10);

	var _shipping2 = _interopRequireDefault(_shipping);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var Option = function Option(_ref) {
	    var label = _ref.label,
	        value = _ref.value,
	        checked = _ref.checked,
	        isDisabled = _ref.isDisabled,
	        onChange = _ref.onChange;
	    return _react2.default.createElement(
	        'label',
	        { className: _shipping2.default.label },
	        _react2.default.createElement('input', {
	            className: _shipping2.default.radioInput,
	            type: 'radio',
	            value: value,
	            checked: checked,
	            onChange: onChange,
	            disabled: isDisabled
	        }),
	        label
	    );
	};

	Option.propTypes = {
	    label: _propTypes2.default.string.isRequired,
	    value: _propTypes2.default.string.isRequired,
	    checked: _propTypes2.default.bool.isRequired,
	    onChange: _propTypes2.default.func.isRequired,
	    isDisabled: _propTypes2.default.bool
	};

	Option.defaultProps = {
	    isDisabled: false
	};

	exports.default = Option;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _classnames = __webpack_require__(22);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _shipping = __webpack_require__(10);

	var _shipping2 = _interopRequireDefault(_shipping);

	var _Primary = __webpack_require__(26);

	var _Primary2 = _interopRequireDefault(_Primary);

	var _dibsOverlaySpinner = __webpack_require__(27);

	var _dibsOverlaySpinner2 = _interopRequireDefault(_dibsOverlaySpinner);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	// components


	var Submit = function Submit(_ref) {
	    var _classNames;

	    var label = _ref.label,
	        isSaving = _ref.isSaving,
	        isDisabled = _ref.isDisabled,
	        onClick = _ref.onClick;

	    var buttonClasses = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, _shipping2.default.submit, true), _defineProperty(_classNames, _shipping2.default.disable, isDisabled), _classNames));
	    return _react2.default.createElement(
	        _Primary2.default,
	        { className: buttonClasses, disabled: isSaving, onClick: onClick },
	        isSaving && _react2.default.createElement(_dibsOverlaySpinner2.default, {
	            size: 'small',
	            position: 'isStatic',
	            additionalWrapperClasses: _shipping2.default.inlineSpinner
	        }),
	        isSaving ? 'Saving...' : label
	    );
	};

	Submit.propTypes = {
	    label: _propTypes2.default.string,
	    isSaving: _propTypes2.default.bool,
	    isDisabled: _propTypes2.default.bool,
	    onClick: _propTypes2.default.func.isRequired
	};

	Submit.defaultProps = {
	    label: 'Save',
	    isSaving: false,
	    isDisabled: false
	};

	exports.default = Submit;

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports = require("dibs-elements/dist/Button/Primary");

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports = require("dibs-overlay-spinner");

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = SuccessContent;

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _dibsElements = __webpack_require__(4);

	var _FollowDealer = __webpack_require__(29);

	var _FollowDealer2 = _interopRequireDefault(_FollowDealer);

	var _arrowRight = __webpack_require__(41);

	var _arrowRight2 = _interopRequireDefault(_arrowRight);

	var _successContent = __webpack_require__(42);

	var _successContent2 = _interopRequireDefault(_successContent);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function SuccessContent(props) {
	    var seller = props.seller,
	        userId = props.userId,
	        isMC = props.isMC,
	        copy = props.copy;


	    return _react2.default.createElement(
	        'div',
	        { 'data-tn': 'shipping-request-modal-success' },
	        _react2.default.createElement(
	            _dibsElements.ModalBody,
	            null,
	            _react2.default.createElement(
	                'p',
	                { className: _successContent2.default.sqrSuccessMessage },
	                copy.get('sqrSuccessMessage')
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: _successContent2.default.sqrSuccessMessage },
	                copy.get('sqrViewRequest'),
	                _react2.default.createElement(
	                    'a',
	                    { href: '/my/conversations/', className: _successContent2.default.sqrSuccessLink },
	                    copy.get('sqrMyConversations'),
	                    _react2.default.createElement(_arrowRight2.default, { className: _successContent2.default.sqrCtaArrow })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _successContent2.default.sqrSuccessFooter },
	            _react2.default.createElement(
	                'div',
	                { className: _successContent2.default.sqrSuccessFooterTitle },
	                copy.get('sqrSuccessFooterTitle')
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _successContent2.default.sqrSuccessFooterText },
	                copy.get('sqrSuccessFooterText')
	            ),
	            _react2.default.createElement(_FollowDealer2.default, {
	                seller: seller,
	                currentUserId: userId,
	                isMC: isMC
	            })
	        )
	    );
	};

	SuccessContent.propTypes = {
	    seller: _react.PropTypes.object.isRequired,
	    userId: _react.PropTypes.string,
	    isMC: _react.PropTypes.bool,
	    copy: _react.PropTypes.object
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _component = __webpack_require__(30);

	var _component2 = _interopRequireDefault(_component);

	var _recompose = __webpack_require__(35);

	var _relay = __webpack_require__(36);

	var _relay2 = _interopRequireDefault(_relay);

	var _redux = __webpack_require__(38);

	var _redux2 = _interopRequireDefault(_redux);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = (0, _recompose.hoistStatics)((0, _recompose.compose)(_redux2.default, _relay2.default))(_component2.default);

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _copyText = __webpack_require__(5);

	var _copyText2 = _interopRequireDefault(_copyText);

	var _lodash = __webpack_require__(31);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _followDealerCopy = __webpack_require__(32);

	var _followDealerCopy2 = _interopRequireDefault(_followDealerCopy);

	var _tracking = __webpack_require__(6);

	var _tracking2 = _interopRequireDefault(_tracking);

	var _styles = __webpack_require__(33);

	var _styles2 = _interopRequireDefault(_styles);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var FollowDealer = function (_Component) {
	    _inherits(FollowDealer, _Component);

	    function FollowDealer(props) {
	        _classCallCheck(this, FollowDealer);

	        var _this = _possibleConstructorReturn(this, (FollowDealer.__proto__ || Object.getPrototypeOf(FollowDealer)).call(this, props));

	        _this.copy = (0, _copyText2.default)().extend(_followDealerCopy2.default);
	        return _this;
	    }

	    _createClass(FollowDealer, [{
	        key: '_followSeller',
	        value: function _followSeller() {
	            var _this2 = this;

	            this.props.favoriteSeller(Object.assign({
	                onFailure: function onFailure() {
	                    return _this2.props.setErrorMessage({ errorMessage: _this2.copy.get('followSellerError') });
	                },
	                onSuccess: function onSuccess() {
	                    return _tracking2.default.trackDealerFollowed({ isMC: _this2.props.isMC });
	                }
	            }, (0, _lodash2.default)(this.props, 'currentUserId', 'seller', 'favoriteId', 'relay')));
	        }
	    }, {
	        key: '_unfollowSeller',
	        value: function _unfollowSeller() {
	            var _this3 = this;

	            this.props.favoriteSeller(Object.assign({
	                onFailure: function onFailure() {
	                    return _this3.props.setErrorMessage({ errorMessage: _this3.copy.get('unFollowSellerError') });
	                },
	                onSuccess: function onSuccess() {
	                    return _tracking2.default.trackDealerUnFollowed({ isMC: _this3.props.isMC });
	                }
	            }, (0, _lodash2.default)(this.props, 'currentUserId', 'seller', 'favoriteId', 'relay')));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                favoriteId = _props.favoriteId,
	                isMC = _props.isMC,
	                errorMessage = _props.errorMessage;


	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    {
	                        onClick: (favoriteId ? this._unfollowSeller : this._followSeller).bind(this),
	                        className: 'button button-primary button-large ' + _styles2.default.followDealerCta,
	                        'data-tn': isMC ? 'mc-follow-dealer-cta' : ''
	                    },
	                    this.copy.get(favoriteId ? 'unfollowSellerCta' : 'followSellerCta')
	                ),
	                errorMessage ? _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.sqrError },
	                    errorMessage
	                ) : null
	            );
	        }
	    }]);

	    return FollowDealer;
	}(_react.Component);

	FollowDealer.propTypes = {
	    seller: _propTypes2.default.object.isRequired,
	    favoriteId: _propTypes2.default.string,
	    company: _propTypes2.default.string.isRequired,
	    favoriteSeller: _propTypes2.default.func.isRequired,
	    setErrorMessage: _propTypes2.default.func.isRequired,
	    currentUserId: _propTypes2.default.string.isRequired,
	    errorMessage: _propTypes2.default.string,
	    isMC: _propTypes2.default.bool
	};

	exports.default = FollowDealer;

/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = require("lodash.pick");

/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports = {
		"followSellerError": "An error occurred when attempting to follow this dealer. Please try again later.",
		"unFollowSellerError": "An error occurred when attempting to no longer follow this dealer. Please try again later.",
		"followSellerCta": "follow dealer",
		"unfollowSellerCta": "dealer followed"
	};

/***/ },
/* 33 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sqrFullWidthBtn":"src-styles---sqrFullWidthBtn---16wyl","sqrModalWrapper":"src-styles---sqrModalWrapper---2i54e","sqrError":"src-styles---sqrError---2HVpJ","sqrSubmitWrapper":"src-styles---sqrSubmitWrapper---301J2","sqrFooterBackLink":"src-styles---sqrFooterBackLink---5UxT-","followDealerCta":"src-styles---followDealerCta---1hFjn"};

/***/ },
/* 34 */,
/* 35 */
/***/ function(module, exports) {

	module.exports = require("recompose");

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _reactRelay = __webpack_require__(16);

	var _reactRelay2 = _interopRequireDefault(_reactRelay);

	var _favoriteSeller = __webpack_require__(37);

	var _favoriteSeller2 = _interopRequireDefault(_favoriteSeller);

	var _recompose = __webpack_require__(35);

	var _lodash = __webpack_require__(9);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var favoriteSeller = function favoriteSeller(_ref) {
	    var currentUserId = _ref.currentUserId,
	        seller = _ref.seller,
	        favoriteId = _ref.favoriteId,
	        relay = _ref.relay,
	        onSuccess = _ref.onSuccess,
	        onFailure = _ref.onFailure;

	    relay.commitUpdate(new _favoriteSeller2.default({
	        currentUserId: currentUserId,
	        seller: seller,
	        favoriteId: favoriteId
	    }), { onSuccess: onSuccess, onFailure: onFailure });
	};

	var query = {
	    initialVariables: {
	        currentUserId: null,
	        shouldFetchFavorites: null
	    },
	    prepareVariables: function prepareVariables(vars) {
	        return Object.assign({}, vars, {
	            shouldFetchFavorites: !!vars.currentUserId
	        });
	    },
	    fragments: {
	        seller: function seller() {
	            return function (RQL_0) {
	                return {
	                    children: [].concat.apply([], [{
	                        calls: [{
	                            kind: 'Call',
	                            metadata: {},
	                            name: 'userIds',
	                            value: {
	                                kind: 'CallVariable',
	                                callVariableName: 'currentUserId'
	                            }
	                        }],
	                        children: [{
	                            fieldName: 'serviceId',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'ID'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        directives: [{
	                            kind: 'Directive',
	                            name: 'include',
	                            args: [{
	                                name: 'if',
	                                value: {
	                                    kind: 'CallVariable',
	                                    callVariableName: 'shouldFetchFavorites'
	                                }
	                            }]
	                        }],
	                        fieldName: 'favoritesByUser',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id',
	                            isPlural: true
	                        },
	                        type: 'Favorite'
	                    }, {
	                        children: [{
	                            fieldName: 'company',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }],
	                        fieldName: 'sellerProfile',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true
	                        },
	                        type: 'SellerProfile'
	                    }, {
	                        fieldName: 'id',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'ID'
	                    }, _reactRelay2.default.QL.__frag(RQL_0)]),
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'Relay_SellerRelayQL',
	                    type: 'Seller'
	                };
	            }(_favoriteSeller2.default.getFragment('seller'));
	        }
	    }
	};

	exports.default = (0, _recompose.hoistStatics)((0, _recompose.compose)(function (BaseComponent) {
	    return _reactRelay2.default.createContainer(BaseComponent, query);
	}, (0, _recompose.flattenProp)('seller'), (0, _recompose.flattenProp)('sellerProfile'), (0, _recompose.withProps)(function (props) {
	    return {
	        favoriteId: (0, _lodash2.default)(props, 'favoritesByUser[0].serviceId'),
	        favoriteSeller: favoriteSeller
	    };
	})));

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Relay = __webpack_require__(16);

	var FavoriteSeller = function (_Relay$Mutation) {
	    _inherits(FavoriteSeller, _Relay$Mutation);

	    function FavoriteSeller() {
	        _classCallCheck(this, FavoriteSeller);

	        return _possibleConstructorReturn(this, (FavoriteSeller.__proto__ || Object.getPrototypeOf(FavoriteSeller)).apply(this, arguments));
	    }

	    _createClass(FavoriteSeller, [{
	        key: 'getMutation',
	        value: function getMutation() {
	            return function () {
	                return {
	                    calls: [{
	                        kind: 'Call',
	                        metadata: {},
	                        name: 'favoriteSeller',
	                        value: {
	                            kind: 'CallVariable',
	                            callVariableName: 'input'
	                        }
	                    }],
	                    children: [{
	                        fieldName: 'clientMutationId',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'String'
	                    }],
	                    kind: 'Mutation',
	                    metadata: {
	                        inputType: 'FavoriteSellerInput!'
	                    },
	                    name: 'FavoriteSeller',
	                    responseType: 'FavoriteSellerPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getVariables',
	        value: function getVariables() {
	            var _props = this.props,
	                currentUserId = _props.currentUserId,
	                serviceId = _props.seller.serviceId,
	                favoriteId = _props.favoriteId;

	            return {
	                userId: currentUserId,
	                sellerPk: serviceId,
	                favoriteId: favoriteId
	            };
	        }
	    }, {
	        key: 'getFatQuery',
	        value: function getFatQuery() {
	            return function () {
	                return {
	                    children: [{
	                        children: [{
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'seller',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Seller'
	                    }],
	                    id: Relay.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'FavoriteSellerRelayQL',
	                    type: 'FavoriteSellerPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getConfigs',
	        value: function getConfigs() {
	            return [{
	                type: 'FIELDS_CHANGE',
	                fieldIDs: { seller: this.props.seller.id }
	            }];
	        }
	    }]);

	    return FavoriteSeller;
	}(Relay.Mutation);

	FavoriteSeller.fragments = {
	    seller: function seller() {
	        return function () {
	            return {
	                children: [{
	                    fieldName: 'id',
	                    kind: 'Field',
	                    metadata: {
	                        isRequisite: true
	                    },
	                    type: 'ID'
	                }, {
	                    fieldName: 'serviceId',
	                    kind: 'Field',
	                    metadata: {},
	                    type: 'ID'
	                }],
	                id: Relay.QL.__id(),
	                kind: 'Fragment',
	                metadata: {},
	                name: 'FavoriteSeller_SellerRelayQL',
	                type: 'Seller'
	            };
	        }();
	    }
	};

	exports.default = FavoriteSeller;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _actions = __webpack_require__(39);

	var _actions2 = _interopRequireDefault(_actions);

	var _reactRedux = __webpack_require__(40);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var mapStateToProps = function mapStateToProps(_ref) {
	  var shippingQuoteModal = _ref.shippingQuoteModal;
	  return { errorMessage: shippingQuoteModal.errorMessage };
	};

	exports.default = (0, _reactRedux.connect)(mapStateToProps, _actions2.default);

/***/ },
/* 39 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    setOpenModalKey: function setOpenModalKey(modalKey) {
	        return {
	            type: 'SQR_SET_OPEN_MODAL_KEY',
	            modalKey: modalKey
	        };
	    },
	    setErrorMessage: function setErrorMessage(_ref) {
	        var errorMessage = _ref.errorMessage;
	        return {
	            type: 'SQR_SET_ERROR_MSG',
	            errorMessage: errorMessage
	        };
	    },
	    setCurrentStep: function setCurrentStep(step) {
	        return {
	            type: 'SQR_SET_CURRENT_STEP',
	            step: step
	        };
	    },
	    clearState: function clearState() {
	        return {
	            type: 'SQR_CLEAR_STATE'
	        };
	    }
	};

/***/ },
/* 40 */
/***/ function(module, exports) {

	module.exports = require("react-redux");

/***/ },
/* 41 */
/***/ function(module, exports) {

	module.exports = require("dibs-vg/dist/react/arrow-right");

/***/ },
/* 42 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sqrCtaArrow":"src-ShippingRequestModal-successContent---sqrCtaArrow---3Um6q","sqrSuccessMessage":"src-ShippingRequestModal-successContent---sqrSuccessMessage---26Kcq","sqrSuccessLink":"src-ShippingRequestModal-successContent---sqrSuccessLink---2JeLC","sqrSuccessFooter":"src-ShippingRequestModal-successContent---sqrSuccessFooter---3PYm0","sqrCta":"src-ShippingRequestModal-successContent---sqrCta---rnGjC","sqrSuccessFooterText":"src-ShippingRequestModal-successContent---sqrSuccessFooterText---cJB5P","sqrSuccessFooterTitle":"src-ShippingRequestModal-successContent---sqrSuccessFooterTitle---1PHiZ"};

/***/ },
/* 43 */,
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _reactRelay = __webpack_require__(16);

	var _reactRelay2 = _interopRequireDefault(_reactRelay);

	var _recompose = __webpack_require__(35);

	var _withProps = __webpack_require__(45);

	var _withProps2 = _interopRequireDefault(_withProps);

	var _FollowDealer = __webpack_require__(29);

	var _FollowDealer2 = _interopRequireDefault(_FollowDealer);

	var _lodash = __webpack_require__(9);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _updateBuyerProfileMutation = __webpack_require__(15);

	var _updateBuyerProfileMutation2 = _interopRequireDefault(_updateBuyerProfileMutation);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var query = {
	    initialVariables: {
	        userId: null,
	        itemId: null,
	        shouldFetchConversation: null,
	        isMC: false
	    },
	    prepareVariables: function prepareVariables(vars) {
	        return Object.assign({}, vars, {
	            shouldFetchConversation: vars.userId && vars.itemId && !vars.isMC
	        });
	    },
	    fragments: {
	        user: function user() {
	            return function (RQL_0) {
	                return {
	                    children: [].concat.apply([], [{
	                        fieldName: 'id',
	                        kind: 'Field',
	                        metadata: {
	                            isRequisite: true
	                        },
	                        type: 'ID'
	                    }, {
	                        children: [{
	                            fieldName: 'displayName',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'firstName',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'lastName',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'email',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }],
	                        fieldName: 'profile',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true
	                        },
	                        type: 'Profile'
	                    }, {
	                        fieldName: 'serviceId',
	                        kind: 'Field',
	                        metadata: {},
	                        type: 'ID'
	                    }, {
	                        children: [{
	                            fieldName: 'serviceId',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'ID'
	                        }, {
	                            fieldName: 'country',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'city',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'state',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'zipCode',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'firstValidShippingAddress',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Address'
	                    }, {
	                        children: [{
	                            children: [{
	                                fieldName: 'sourceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'serviceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'ID'
	                            }, {
	                                fieldName: 'displayName',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'formattedAddress',
	                                kind: 'Field',
	                                metadata: {
	                                    isPlural: true
	                                },
	                                type: 'String'
	                            }, {
	                                fieldName: 'displayCountry',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'firstName',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'lastName',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'line1',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'line2',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'country',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'city',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'state',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'zipCode',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'phoneNumber',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                children: [{
	                                    children: [{
	                                        fieldName: 'valid',
	                                        kind: 'Field',
	                                        metadata: {},
	                                        type: 'YesNo'
	                                    }],
	                                    fieldName: 'buyerShipping',
	                                    kind: 'Field',
	                                    metadata: {
	                                        canHaveSubselections: true
	                                    },
	                                    type: 'ValidationResult'
	                                }],
	                                fieldName: 'validation',
	                                kind: 'Field',
	                                metadata: {
	                                    canHaveSubselections: true
	                                },
	                                type: 'AddressValidation'
	                            }, {
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isGenerated: true,
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }],
	                            fieldName: 'addressList',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id',
	                                isPlural: true
	                            },
	                            type: 'Address'
	                        }],
	                        fieldName: 'addressBook',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true
	                        },
	                        type: 'AddressBook'
	                    }, _reactRelay2.default.QL.__frag(RQL_0)]),
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'Relay_UserRelayQL',
	                    type: 'User'
	                };
	            }(_updateBuyerProfileMutation2.default.getFragment('user'));
	        },
	        // conversation fragment is only used in MC, where we never need to update the buyer profile
	        conversation: function conversation(_ref) {
	            var userId = _ref.userId;
	            return function (RQL_0) {
	                return {
	                    children: [{
	                        fieldName: 'serviceId',
	                        kind: 'Field',
	                        metadata: {},
	                        type: 'ID'
	                    }, {
	                        fieldName: 'id',
	                        kind: 'Field',
	                        metadata: {
	                            isRequisite: true
	                        },
	                        type: 'ID'
	                    }, {
	                        children: [{
	                            fieldName: 'serviceId',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'ID'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'transaction',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Transaction'
	                    }, {
	                        children: [{
	                            children: [{
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }, {
	                                fieldName: 'serviceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'ID'
	                            }, {
	                                children: [{
	                                    fieldName: 'displayName',
	                                    kind: 'Field',
	                                    metadata: {},
	                                    type: 'String'
	                                }, {
	                                    fieldName: 'email',
	                                    kind: 'Field',
	                                    metadata: {},
	                                    type: 'String'
	                                }],
	                                fieldName: 'profile',
	                                kind: 'Field',
	                                metadata: {
	                                    canHaveSubselections: true
	                                },
	                                type: 'Profile'
	                            }],
	                            fieldName: 'user',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id'
	                            },
	                            type: 'User'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'originalBuyer',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'ConversationMember'
	                    }, {
	                        children: [{
	                            children: [].concat.apply([], [{
	                                fieldName: 'serviceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'ID'
	                            }, {
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isGenerated: true,
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }, _reactRelay2.default.QL.__frag(RQL_0)]),
	                            fieldName: 'seller',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id'
	                            },
	                            type: 'Seller'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'originalSeller',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'ConversationMember'
	                    }],
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'Relay_ConversationRelayQL',
	                    type: 'Conversation'
	                };
	            }(_FollowDealer2.default.getFragment('seller', { currentUserId: userId }));
	        },
	        viewer: function viewer(_ref2) {
	            var userId = _ref2.userId;
	            return function (RQL_0) {
	                return {
	                    children: [{
	                        alias: 'conversation',
	                        calls: [{
	                            kind: 'Call',
	                            metadata: {},
	                            name: 'buyerId',
	                            value: {
	                                kind: 'CallVariable',
	                                callVariableName: 'userId'
	                            }
	                        }, {
	                            kind: 'Call',
	                            metadata: {},
	                            name: 'itemId',
	                            value: {
	                                kind: 'CallVariable',
	                                callVariableName: 'itemId'
	                            }
	                        }],
	                        children: [{
	                            fieldName: 'serviceId',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'ID'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }, {
	                            children: [{
	                                fieldName: 'serviceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'ID'
	                            }, {
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }, {
	                                fieldName: 'isCanceled',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'Boolean'
	                            }, {
	                                fieldName: 'hasCompletedCheckout',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'Boolean'
	                            }, {
	                                children: [{
	                                    fieldName: 'id',
	                                    kind: 'Field',
	                                    metadata: {
	                                        isRequisite: true
	                                    },
	                                    type: 'ID'
	                                }],
	                                fieldName: 'requestedQuote',
	                                kind: 'Field',
	                                metadata: {
	                                    canHaveSubselections: true,
	                                    inferredRootCallName: 'node',
	                                    inferredPrimaryKey: 'id'
	                                },
	                                type: 'ShipmentQuote'
	                            }],
	                            fieldName: 'transaction',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id'
	                            },
	                            type: 'Transaction'
	                        }],
	                        directives: [{
	                            kind: 'Directive',
	                            name: 'include',
	                            args: [{
	                                name: 'if',
	                                value: {
	                                    kind: 'CallVariable',
	                                    callVariableName: 'shouldFetchConversation'
	                                }
	                            }]
	                        }],
	                        fieldName: 'buyerItemConversation',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Conversation'
	                    }, {
	                        calls: [{
	                            kind: 'Call',
	                            metadata: {},
	                            name: 'itemId',
	                            value: {
	                                kind: 'CallVariable',
	                                callVariableName: 'itemId'
	                            }
	                        }],
	                        children: [{
	                            fieldName: 'title',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            children: [].concat.apply([], [{
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isGenerated: true,
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }, _reactRelay2.default.QL.__frag(RQL_0)]),
	                            fieldName: 'seller',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id'
	                            },
	                            type: 'Seller'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        directives: [{
	                            kind: 'Directive',
	                            name: 'skip',
	                            args: [{
	                                name: 'if',
	                                value: {
	                                    kind: 'CallVariable',
	                                    callVariableName: 'isMC'
	                                }
	                            }]
	                        }],
	                        fieldName: 'item',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Item'
	                    }, {
	                        fieldName: 'id',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'ID'
	                    }],
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'Relay_ViewerRelayQL',
	                    type: 'Viewer'
	                };
	            }(_FollowDealer2.default.getFragment('seller', { currentUserId: userId }));
	        },
	        item: function item() {
	            return function () {
	                return {
	                    children: [{
	                        fieldName: 'title',
	                        kind: 'Field',
	                        metadata: {},
	                        type: 'String'
	                    }, {
	                        fieldName: 'id',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'ID'
	                    }],
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'Relay_ItemRelayQL',
	                    type: 'Item'
	                };
	            }();
	        }
	    }
	};

	exports.default = function (Component) {
	    return (0, _recompose.hoistStatics)((0, _recompose.compose)(function (BaseComponent) {
	        return _reactRelay2.default.createContainer(BaseComponent, query);
	    }, (0, _withProps2.default)(function (baseProps) {
	        var user = baseProps.user,
	            isMC = baseProps.isMC,
	            viewer = baseProps.viewer;

	        var conversation = void 0;
	        var item = void 0;
	        var extraProps = void 0;

	        if (isMC) {
	            conversation = (0, _lodash2.default)(baseProps, 'conversation');
	            item = (0, _lodash2.default)(baseProps, 'item');
	            extraProps = {
	                user: (0, _lodash2.default)(conversation, 'originalBuyer.user'),
	                userId: (0, _lodash2.default)(conversation, 'originalBuyer.user.serviceId'),
	                userRelayId: (0, _lodash2.default)(conversation, 'originalBuyer.user.id'),
	                buyerDisplayName: (0, _lodash2.default)(conversation, 'originalBuyer.user.profile.displayName'),
	                dealerPk: (0, _lodash2.default)(conversation, 'originalSeller.seller.serviceId')
	            };
	        } else {
	            conversation = (0, _lodash2.default)(viewer, 'conversation');
	            item = (0, _lodash2.default)(viewer, 'item');
	            extraProps = {
	                requestedShipmentQuote: (0, _lodash2.default)(conversation, 'transaction.requestedQuote'),
	                transactionHasCompletedCheckout: (0, _lodash2.default)(conversation, 'transaction.hasCompletedCheckout'),
	                transactionIsCanceled: (0, _lodash2.default)(conversation, 'transaction.isCanceled'),
	                userRelayId: (0, _lodash2.default)(user, 'id'),
	                buyerDisplayName: (0, _lodash2.default)(user, 'profile.displayName')
	            };
	        }

	        return Object.assign({}, {
	            itemTitle: (0, _lodash2.default)(item, 'title'),
	            conversationId: (0, _lodash2.default)(conversation, 'serviceId'),
	            conversationRelayId: (0, _lodash2.default)(conversation, 'id'),
	            transactionId: (0, _lodash2.default)(conversation, 'transaction.serviceId'),
	            transactionRelayId: (0, _lodash2.default)(conversation, 'transaction.id'),
	            seller: (0, _lodash2.default)(conversation, 'originalSeller.seller') || (0, _lodash2.default)(item, 'seller')
	        }, extraProps);
	    })))(Component);
	};

/***/ },
/* 45 */
/***/ function(module, exports) {

	module.exports = require("recompose/withProps");

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _reactRedux = __webpack_require__(40);

	var _actions = __webpack_require__(39);

	var _actions2 = _interopRequireDefault(_actions);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = (0, _reactRedux.connect)(function (_ref) {
	    var shippingQuoteModal = _ref.shippingQuoteModal;
	    return shippingQuoteModal;
	}, _actions2.default);

/***/ },
/* 47 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var defaultState = {
	    errorMessage: '',
	    currentStep: 'quoteRequest',
	    openModalKey: ''
	};

	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];

	    switch (action.type) {
	        case 'SQR_SET_OPEN_MODAL_KEY':
	            return Object.assign({}, state, {
	                openModalKey: action.modalKey
	            });
	        case 'SQR_SET_ERROR_MSG':
	            return Object.assign({}, state, {
	                errorMessage: action.errorMessage
	            });
	        case 'SQR_SET_CURRENT_STEP':
	            return Object.assign({}, state, {
	                currentStep: action.step
	            });
	        case 'SQR_CLEAR_STATE':
	            return defaultState;
	        default:
	            return state;
	    }
	};

/***/ }
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./~/dibs-request-shipping-modal/dist/bundle.js
// module id = 1116
// module chunks = 4 14